<style lang="scss" src='./CustomSwitch.scss' scoped></style>
<template src="./CustomSwitch.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  export default {
    name: 'CustomSwitch',
    props: {
      product: {
        type: Object,
        required: false,
      },
    },
    components: {},
    data() {
      return {
        swState: false,
        cartProduct : null,
      }
    },
    computed: {
      ...mapState('CartStore', ['cartProducts']),
    },
    watch:{
      cartProducts: {
        handler: function () {
          this.fnFindProduct();
        },
        deep: true,
      }
    },
    methods: {
      fnFindProduct() {
        if(this.product && this.cartProducts && this.cartProducts.products.length > 0){
          this.cartProduct = this.cartProducts.products.find(item => item._id == this.product._id);
          if(this.cartProduct && this.cartProduct.unit == 'PZA'){
            this.swState = true;
          }else{
            this.swState = false;
          }
        }
      },
    },
    beforeCreate() {},
    created() {
    },
    async mounted() {
      if(this.product && this.product.unit == 'PZA'){
        this.swState = true;
      }else{
        this.swState = false;
      }
    },
    beforeDestroy() {},
  };

</script>
